/*
 * Analytics providers
 *
 * A provider is an object with a handler per event type from analytics.js. Each handler is called with
 * the current session ({clientId, sessionId}) and the event data. Leave a handler out to ignore that event.
 *
 * `session` is null unless the site is generating its own sessions (the tablet kiosk). Otherwise the
 * analytics tool works out visitors and sessions itself, so leave the IDs alone.
 *
 *   session_start    - a new visitor's session has begun (custom sessions only)
 *   page_view        - data: {path, title, slug}
 *   video_view       - data: {name, slug}
 *   session_timeout  - visitor has finished, session is over (custom sessions only)
 *
 * To swap tools: write a new provider, add it to the list at the bottom, and add its loader snippet to
 * templates/Includes/Requirements_extra.ss.
 */

function analyticsGoogleParams(session, params) {
    if (session) {
        params.session_id = session.sessionId;
    }
    return params;
}

// Google Analytics (GA4) https://developers.google.com/analytics/devguides/collection/ga4/events
const analyticsGoogle = {
    session_start: function (session) {
        if (typeof window.gtag !== 'function') return;
        window.gtag('set', {client_id: session.clientId, session_id: session.sessionId});
    },

    page_view: function (session, page) {
        if (typeof window.gtag !== 'function') return;
        // In the tablet kiosk the URL never changes, so the page has to be spelled out
        window.gtag('event', 'page_view', analyticsGoogleParams(session, {
            page_path: page.path,
            page_title: page.title,
            page_location: window.location.origin + page.path,
        }));
    },

    video_view: function (session, video) {
        if (typeof window.gtag !== 'function') return;
        window.gtag('event', 'video_view', analyticsGoogleParams(session, {name: video.name}));
    },

    session_timeout: function (session) {
        if (typeof window.gtag !== 'function') return;
        window.gtag('event', 'session_timeout', {session_id: session.sessionId});
    },
};

// Microsoft Clarity https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api
const analyticsClarity = {
    session_start: function (session) {
        if (typeof window.clarity !== 'function') return;
        window.clarity('identify', session.clientId, String(session.sessionId));
    },

    page_view: function (session, page) {
        if (typeof window.clarity !== 'function') return;
        window.clarity('event', 'page_view_' + page.slug);
    },

    video_view: function (session, video) {
        if (typeof window.clarity !== 'function') return;
        window.clarity('event', 'video_view_' + video.slug);
    },

    session_timeout: function () {
        if (typeof window.clarity !== 'function') return;
        window.clarity('event', 'session_timeout');
    },
};

const analyticsProviders = [analyticsGoogle, analyticsClarity];
